import { createSelector } from '@ngrx/store';
import map from 'lodash/map';
import filter from 'lodash/filter';
import uniq from 'lodash/uniq';
import flatten from 'lodash/flatten';
import includes from 'lodash/includes';

import { selectDecoratorsState } from './decorators.selector';
import { CommentStatus, ITrackChange } from '../../models';
import { CommentCategoryEnum } from '../../../../model';
export const getTrackChange = createSelector(
  selectDecoratorsState,
  ({ trackChangeData }): ITrackChange => trackChangeData
);

export const getRHPTrackChange = createSelector(
  selectDecoratorsState,
  ({ trackChangeRHPData }): ITrackChange => trackChangeRHPData
);

export const getUserPreferenceForTrackChangesView = createSelector(
  selectDecoratorsState,
  ({ userPreferenceForTrackChangesView }): string =>
    userPreferenceForTrackChangesView
);

export const getUniqueUserIds = createSelector(
  getTrackChange,
  ({ commentThreads, suggestions }): string[] => {
    const uniqueUsersInTrackChanges = map(suggestions, (ele) => ele.authorId);
    const comments = flatten(
      map(commentThreads, ({ comments: threadComments }) => threadComments)
    );
    const uniqueUsersInComments = map(comments, ({ authorId }) => authorId);
    return uniq([
      ...uniqueUsersInTrackChanges,
      ...uniqueUsersInComments,
    ]) as string[];
  }
);

export const getResolveCommentIds = createSelector(
  getTrackChange,
  ({ commentThreads }): string[] =>
    map(
      filter(
        commentThreads,
        (thread) =>
          thread.comments?.[0]?.attributes?.status === CommentStatus.RESOLVE
      ),
      ({ threadId }) => threadId
    )
);

export const getThreadCount = createSelector(
  getTrackChange,
  ({ commentThreads, suggestions }): number => {
    return (
      filter(
        commentThreads,
        (thread) =>
          thread.comments?.[0]?.attributes?.status !== CommentStatus.RESOLVE &&
          !thread.isRHPComment
      ).length + filter(suggestions, (s) => !s.isRHPSuggestion).length
    );
  }
);

export const getCommentThreadCount = createSelector(
  getTrackChange,
  ({ commentThreads }): number =>
    filter(commentThreads, (thread) => {
      const commentAttr = thread.comments?.[0]?.attributes;
      return (
        commentAttr?.status !== CommentStatus.RESOLVE &&
        includes(
          [CommentCategoryEnum.EDITORIAL, CommentCategoryEnum.RELEASE_NOTES],
          commentAttr?.commentType
        )
      );
    }).length
);

export const getSelectedCommentsTabIndex = createSelector(
  selectDecoratorsState,
  ({ selectedCommentsTabIndex }): number => selectedCommentsTabIndex
);
